angular.module('CarsSaraBo').factory('FleetUpgradeService', ['$resource', function($resource) {
  
  return {
    resourceCarUpgrade: $resource('../rest/company/:companyOid/fleet/upgradables',
		  {
        companyOid: '@companyOid'
      },  
		  {
			  fetchUpgradables: {method: 'GET'}
      }
    ),
    fetchUpgradables: function (companyOid) {
      return this.resourceCarUpgrade.fetchUpgradables({companyOid: companyOid}).$promise;
    }
  };
}]);


//////////////////
// WEBPACK FOOTER
// ./public/app/models/fleet_upgrade_service.js
// module id = 846
// module chunks = 3